(function () {
  var assetBase = (window.fictionStoriesAssetBase || "").replace(/\?.*$/, "");

  function setup(el) {
    var slug = el.getAttribute("data-brand");
    // Prefer the new one-liner caption set when present; else fall back to the
    // original timeline data (leaves brands not in fictionCaptions untouched).
    var data = (window.fictionCaptions || {})[slug] || (window.fictionStories || {})[slug];
    if (!data || !data.length) {
      el.style.display = "none";
      return;
    }
    var track = el.querySelector("[data-fs-track]");
    var dots = el.querySelector("[data-fs-dots]");

    data.forEach(function (b, i) {
      // SLIDE 1 — image with handwritten year overlay
      var imgSlide = document.createElement("article");
      imgSlide.className = "fiction-mag__slide fiction-mag__slide--image";
      imgSlide.setAttribute("data-fs-slide", i * 2);
      imgSlide.setAttribute("data-fs-beat", i);
      imgSlide.innerHTML =
        '<div class="fiction-mag__slide-media">' +
          '<img src="' + assetBase + b.image + '" alt="' + escapeAttr(b.title ? (b.year + " — " + b.title) : (b.caption || "")) + '" loading="' + (i === 0 ? "eager" : "lazy") + '" decoding="async">' +
          (b.year ? '<span class="fiction-mag__scribble">' + escapeHtml(b.year) + '</span>' : '') +
        '</div>';
      track.appendChild(imgSlide);

      // SLIDE 2 — text page (cream paper, year + title, caption with kicker colored)
      // Trim to first + last paragraph if 3+ paragraphs (setup + kicker, drop middle)
      var paras = (b.caption || "")
        .split(/\n+/)
        .map(function (p) { return p.trim(); })
        .filter(function (p) { return p; });
      if (paras.length >= 3) {
        paras = [paras[0], paras[paras.length - 1]];
      }
      var lastIdx = paras.length - 1;
      var paraHtml = paras.map(function (p, idx) {
        var cls = "fiction-mag__caption-para" + (idx === lastIdx && paras.length > 1 ? " fiction-mag__caption-kicker" : "");
        return '<p class="' + cls + '">' + escapeHtml(p) + '</p>';
      }).join("");

      var txtSlide = document.createElement("article");
      txtSlide.className = "fiction-mag__slide fiction-mag__slide--text";
      txtSlide.setAttribute("data-fs-slide", i * 2 + 1);
      txtSlide.setAttribute("data-fs-beat", i);
      txtSlide.innerHTML =
        '<div class="fiction-mag__slide-text">' +
          (b.title ? '<h4 class="fiction-mag__caption-head">' + escapeHtml(b.title) + '</h4>' : '') +
          paraHtml +
        '</div>';
      track.appendChild(txtSlide);

      // One dot per BEAT, not per slide
      var dot = document.createElement("button");
      dot.type = "button";
      dot.className = "fiction-mag__dot" + (i === 0 ? " is-active" : "");
      dot.setAttribute("data-fs-dot", i);
      dot.setAttribute("aria-label", "Beat " + (i + 1));
      dot.addEventListener("click", function () { goToBeat(i); });
      dots.appendChild(dot);
    });

    function setActiveBeat(beatIdx) {
      dots.querySelectorAll(".fiction-mag__dot").forEach(function (d, idx) {
        d.classList.toggle("is-active", idx === beatIdx);
      });
    }
    function activeSlide() {
      var tr = track.getBoundingClientRect();
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < track.children.length; i++) {
        var r = track.children[i].getBoundingClientRect();
        var d = Math.abs(r.left - tr.left);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }
    function goToSlide(i) {
      if (i < 0) i = 0;
      if (i >= track.children.length) i = track.children.length - 1;
      var s = track.children[i];
      s.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
      setActiveBeat(Math.floor(i / 2));
    }
    function goToBeat(beatIdx) {
      goToSlide(beatIdx * 2);
    }

    var scrollT;
    track.addEventListener("scroll", function () {
      if (scrollT) cancelAnimationFrame(scrollT);
      scrollT = requestAnimationFrame(function () {
        setActiveBeat(Math.floor(activeSlide() / 2));
      });
    }, { passive: true });

    el.querySelector("[data-fs-prev]").addEventListener("click", function () { goToSlide(activeSlide() - 1); });
    el.querySelector("[data-fs-next]").addEventListener("click", function () { goToSlide(activeSlide() + 1); });
  }

  function escapeHtml(s) {
    return String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  function escapeAttr(s) {
    return escapeHtml(s).replace(/"/g, "&quot;");
  }

  // "Shop All ↓" buttons — scroll to the on-page hats grid
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-fm-shop-all]");
    if (!btn) return;
    var grid = document.getElementById("fiction-lp-grid");
    if (grid) grid.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  function init() {
    document.querySelectorAll("[data-fiction-mag]").forEach(setup);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
